module.exports = __webpack_public_path__ + "static/media/closedTickets.98ce960e.svg";